module.exports = __webpack_public_path__ + "img/footer-call.cb2e8f8e.svg";